import { fetchUserConnections } from '@/services/apiServices/userConnectionsService';
import { authErrorHandler } from '@/services/errorServices/authHandler.js';

import { manageFollowState } from '../../services/apiServices/userConnectionsService';

/**
 * Vuex actions for the "subscribe" module.
 *
 * Fetches a user's following/followers connections (initial load and
 * paginated loading), and manages follow/unfollow state for a user or
 * channel, committing results into the generic following/followers
 * collections in state.
 */
export default {
  /** Fetch connections for `params.type` (following/followers) and replace that collection in state. */
  async fetchConnections({ commit }, params) {
    const data = await fetchUserConnections(params);

    if (data) {
      commit('setGenericCollection', {
        params: params,
        data: data,
      });

      return data;
    } else {
      console.error(`Failed to fetch ${params.type} connections.`);
    }
  },

  // async fetchFollowing({ commit }, payload) {
  //   const response = await this.$axios.get("/following");
  //   commit("setFollowing", response.data);
  // },
  // async follow({ commit }, payload) {
  //   await this.$axios.post("/follow", payload);
  //   commit("addFollow", payload);
  // },

  /** Fetch the next page of connections for `payload.tab` and append the results to that collection. */
  async setNextPagonationElements({ commit }, payload) {
    const params = {
      type: payload.tab,
      userId: payload.userId,
      offset: payload.offset,
      limit: payload.limit,
      // lastId: payload.lastId,
      only: payload.only,
      verified: payload.verified,
      withUnreadPosts: payload.withUnreadPosts,
    };

  const response = await fetchUserConnections(params);

    if (response && Array.isArray(response.results) && response.results.length > 0) {
      commit('addToGenericCollection', {
        collection: payload.tab,
        data: response.results,
      });
    }

    if (response && response.statusCode) {
      authErrorHandler(response);
    }
    return response && Array.isArray(response.results) ? response.results : [];
  },

  /** Append `payload.data` to the `payload.collection` list in state. */
  addConnectionsCollection({ commit }, payload) {
    commit('addToGenericCollection', payload);
  },

  /** Follow or unfollow a user/channel (`payload.status` toggles the "monitor" variant for follows); returns whether the call succeeded. */
  async manageConnection({ commit }, payload) {
    const response = await manageFollowState(payload.userId, payload.type, payload.status, payload.isChannel);
    return typeof response !== 'undefined' ? Boolean(response) : false;
  },
};
